export const ensureUiState = (state, initialState) => {
  if (!state.ui) {
    state.ui = { ...initialState.ui };
  }
};

export const getPreserveFacetsForFilterOut = ({
  isNewPage,
  itemCount,
  stateSnapshot,
  hasFilterReturnedNoResults,
  filterCurrentPrice
}) =>
  !isNewPage && hasFilterReturnedNoResults(itemCount, stateSnapshot)
    ? {
        facets: stateSnapshot.facets,
        range: stateSnapshot.range,
        selectedFacets: filterCurrentPrice(stateSnapshot.oldSelectedFacets)
      }
    : null;
